import LanguageSelector from "./languageSelector";
import { useI18n } from "../../i18n";
import React from "react";
import { Link } from "react-router-dom";

import styles from "./styles/navBar.module.css";

const NavBar = (props) => {
  const { active } = props;
  const { t, localizedPath } = useI18n();

  return (
    <React.Fragment>
      <LanguageSelector />
      <div className={styles["nav-container"]}>
        <nav aria-label={t("navigation")} className={styles["navbar"]}>
          <div className={styles["nav-background"]}>
            <ul className={styles["nav-list"]}>
              <li
                className={
                  active === "home"
                    ? `${styles["nav-item"]} ${styles.active}`
                    : styles["nav-item"]
                }
              >
                <Link to={localizedPath("/")}>{t("home")}</Link>
              </li>
              <li
                className={
                  active === "projects"
                    ? `${styles["nav-item"]} ${styles.active}`
                    : styles["nav-item"]
                }
              >
                <Link to={localizedPath("/projects")}>{t("projects")}</Link>
              </li>
              <li
                className={
                  active === "experience"
                    ? `${styles["nav-item"]} ${styles.active}`
                    : styles["nav-item"]
                }
              >
                <Link to={localizedPath("/experience")}>{t("experience")}</Link>
              </li>
              <li
                className={
                  active === "contact"
                    ? `${styles["nav-item"]} ${styles.active}`
                    : styles["nav-item"]
                }
              >
                <Link to={localizedPath("/contact")}>{t("contact")}</Link>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </React.Fragment>
  );
};

export default NavBar;
